import { getSavedOpportunitySnapshot } from '@/entities/opportunity';
import { OpportunityDetail } from '@/features/social-media-opportunities-widget';
import { ResolveArtifactPreview } from './ResolveArtifactPreview';

interface Props {
  artifactId: string;
}

/**
 * Library preview for a saved opportunity artifact. The artifact stores a
 * self-contained opportunity snapshot in its data, so we read that by artifact
 * id and mount the flag-aware OpportunityDetail read-only. The snapshot keeps
 * rendering even if the source opportunity is later removed. Falls back to the
 * generic fallback if the artifact can't be resolved.
 */
export function OpportunityArtifactPreview({ artifactId }: Props) {
  return (
    <ResolveArtifactPreview
      queryKey="opportunity-artifact-snapshot"
      artifactId={artifactId}
      queryFn={getSavedOpportunitySnapshot}
      render={(item) => <OpportunityDetail item={item} readOnly />}
    />
  );
}
